import app from '../../angular_app.es6';
import baseHandler from './package_details/base_handler.es6';

app.controller('DetailsPackageController', [
  '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope',
  ($scope, Notification, $timeout, $http, $element, $interval, $rootScope) => {
    baseHandler($scope, Notification, $timeout, $http, $element, $interval, $rootScope);
  }
]);
